"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.podcastComponent = exports.PodcastComponent = void 0;
const app_1 = require("app");
const PodcastPlayer_1 = require("./PodcastPlayer");
class PodcastComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.podcast-component';
        this.OnInit = () => {
            this.el.forEach((el, index) => {
                const playerOrderOnPage = index + 1;
                this.renderPodcastComponent(el, playerOrderOnPage);
            });
        };
    }
    renderPodcastComponent(el, index) {
        const podcast = {
            title: app_1.AttrService.data(el, 'episode-title'),
            link: app_1.AttrService.data(el, 'episode-link'),
            src: app_1.AttrService.data(el, 'episode-audio-link'),
            podcastLink: app_1.AttrService.data(el, 'podcast-url'),
        };
        (0, PodcastPlayer_1.renderPodcastComponent)(el, podcast, index);
    }
}
exports.PodcastComponent = PodcastComponent;
exports.podcastComponent = new PodcastComponent();
